import React from 'react';
import { Container, Box, Grid, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const FooterSection = ({ FadeInSection }) => {
    const Content = FadeInSection || React.Fragment;

    return (
        <Box component="footer">
            <Box sx={{ py: 3, bgcolor: '#fff', borderTop: '1px solid', borderColor: 'grey.200' }}>
                <Container maxWidth="lg">
                    <Content>
                        <Box
                            component={RouterLink}
                            to="/dotacja"
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                alignItems: { xs: 'flex-start', md: 'center' },
                                justifyContent: 'space-between',
                                gap: 2,
                                textDecoration: 'none'
                            }}
                        >
                            <Box sx={{ maxWidth: 640 }}>
                                <Typography variant="body2" sx={{ color: 'grey.800', fontWeight: 700, mb: 0.5 }}>
                                    Projekt dofinansowany ze środków Unii Europejskiej
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'grey.700' }}>
                                    „Wsparcie rozwoju projektu FindSolution.eu” — wkład Funduszy Europejskich: 599 964,00 PLN
                                </Typography>
                            </Box>
                            <Box
                                component="img"
                                src="/eu-dofinansowanie.png"
                                alt="Fundusze Europejskie dla Polski Wschodniej, Rzeczpospolita Polska, Dofinansowane przez Unię Europejską"
                                sx={{ width: '100%', maxWidth: 460, height: 'auto' }}
                            />
                        </Box>
                    </Content>
                </Container>
            </Box>
            <Box sx={{ py: 4, bgcolor: 'grey.800' }}>
            <Container maxWidth="lg">
                <Content>
                    <Grid container spacing={4} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" sx={{ color: 'grey.300' }}>
                                © 2024 - {new Date().getFullYear()} Find solution. Wszystkie prawa zastrzeżone.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
                            <Link
                                href="/assets/Polityka prywatności.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    color: 'grey.300',
                                    mr: 2,
                                    textDecoration: 'none',
                                    '&:hover': { color: 'grey.100', textDecoration: 'underline' }
                                }}
                            >
                                Polityka Prywatności
                            </Link>
                            <Link
                                href="/assets/KLAUZULA INFORMACYJNA GS.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    color: 'grey.300',
                                    mr: 2,
                                    textDecoration: 'none',
                                    '&:hover': { color: 'grey.100', textDecoration: 'underline' }
                                }}
                            >
                                Klauzula Informacyjna
                            </Link>
                            <Link
                                href="/assets/Regulamin.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    color: 'grey.300',
                                    mr: 2,
                                    textDecoration: 'none',
                                    '&:hover': { color: 'grey.100', textDecoration: 'underline' }
                                }}
                            >
                                Regulamin
                            </Link>
                            <Link
                                component={RouterLink}
                                to="/dotacja"
                                sx={{
                                    color: 'grey.300',
                                    textDecoration: 'none',
                                    '&:hover': { color: 'grey.100', textDecoration: 'underline' }
                                }}
                            >
                                Dofinansowanie
                            </Link>
                        </Grid>
                    </Grid>
                </Content>
            </Container>
            </Box>
        </Box>
    );
};

export default FooterSection;
